import type { ContentScrollOffset } from "./content-scroll"

export const VC_CONTENT_VIEW_MSG = "vc_content_view"
export const VC_CONTENT_VIEW_REQUEST = "vc_content_view_request"

export interface LayerSnapshot {
  peerId: string
  local: boolean
  json: string
}

export interface ContentViewSnapshot {
  layers: LayerSnapshot[]
  contentScroll: ContentScrollOffset
  undoStack: string[]
  redoStack: string[]
}

export function emptyContentViewSnapshot(localPeerId: string): ContentViewSnapshot {
  return {
    layers: [
      {
        peerId: localPeerId,
        local: true,
        json: JSON.stringify({
          attrs: { peerId: localPeerId, local: true },
          className: "Layer",
          children: [],
        }),
      },
    ],
    contentScroll: { scrollLeft: 0, scrollTop: 0 },
    undoStack: [],
    redoStack: [],
  }
}
